// EPL-primary competition selection (MULTI-COMP D2, owner 2026-07-05:
// "always resolve primarily to EPL").
//
// Mirrors the backend's settings.PRIMARY_COMPETITION_ID (internal DB id 1 =
// EPL). A contest's `competitions` list is single-element today; if a
// mixed-competition slate ever surfaces, every page-level single-competition
// surface (OPRK context label, player-profile competition context) resolves
// to EPL rather than to whatever happens to be first in the list. Per-player
// competition context is the follow-up if/when combined slates are surfaced.
export const PRIMARY_COMPETITION_ID = 1;

export function primaryCompetition<T extends { id: number }>(
    competitions: T[] | null | undefined
): T | null {
    if (!competitions || competitions.length === 0) return null;
    return competitions.find((c) => c.id === PRIMARY_COMPETITION_ID) ?? competitions[0];
}
